export default __webpack_public_path__ + "static/media/line.d9e9b3c8.svg";